//create a logo component that is a svg image
import { Box } from '@mui/material';



const Logo = () => {
    return (
       <Box>
        <img src="logo.svg " alt="Logo"  width={100} height={100} />
       </Box>
    );
};

export default Logo;